import React from "react";
import BioPanel from "./Panels/BioPanel";
import { useFilter } from "../context/FilterContext";
import InterestsPanel from "./Panels/InterestsPanel";
import ExperiencePanel from "./Panels/ExperiencePanel";
import IndexJSPanel from "./Panels/IndexJSPanel";
import MeReadPanel from "./Panels/MeReadPanel";

const Panel = () => {
  const { selectedFilter } = useFilter();

  const fileInfo = () => {
    if (selectedFilter === "bio") {
      return <BioPanel />;
    } else if (selectedFilter === "interests") {
      return <InterestsPanel />;
    } else if (selectedFilter === "experience") {
      return <ExperiencePanel />;
    } else if (selectedFilter === "index.js") {
      return <IndexJSPanel />;
    } else if (selectedFilter === "README.md") {
      return <MeReadPanel />;
    }
  };

  return <div className="panel">{fileInfo()}</div>;
};

export default Panel;
